export default function isIE() {
  return /(MSIE|Trident|Edge)/.test(navigator.userAgent);
}
